const part = [
    {
        path: 'distributionStation-management-list',
        name: 'distributionStation-management-list',
        meta: {
            icon: 'md-people',
            title: '转运站列表',
            notCache: true,
            access: ['S', 'D'],
            items: [
            ]
        },
        component: () => import('@/view/distributionStation-management/distributionStation-list/distributionStation-list')
    }
    // {
    //     path: 'station-qualify-fail-report-list',
    //     name: 'station-qualify-fail-report-list',
    //     meta: {
    //         icon: 'ios-medical',
    //         title: '质检不合格通知书',
    //         notCache: true,
    //         access: ['D', 'S'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/warehouse-management/qualifyFail-report/qualifyFail-report-list')
    // },
    // {
    //     path: 'distributionStation-product-store',
    //     name: 'distributionStation-product-store',
    //     meta: {
    //         icon: 'md-people',
    //         title: '转运站产品仓存',
    //         notCache: true,
    //         hideInMenu: true,
    //         access: ['S', 'D'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/distributionStation-management/distributionStation-product-store/distributionStation-product-store-list')
    // }
    // {
    //     path: 'distributionStation-delivery-list',
    //     name: 'distributionStation-delivery-list',
    //     meta: {
    //         icon: 'md-people',
    //         title: '预售定单送货',
    //         notCache: true,
    //         access: ['S', 'D'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/distributionStation-management/distributionStation-delivery/preSale-distributionStation-delivery-list')
    // },
    // {
    //     path: 'cur-sale-distributionStation-delivery-list',
    //     name: 'cur-sale-distributionStation-delivery-list',
    //     meta: {
    //         icon: 'md-people',
    //         title: '现售单送货',
    //         notCache: true,
    //         access: ['S', 'D'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/distributionStation-management/distributionStation-delivery/curSale-distributionStation-delivery-list')
    // },
    // {
    //     path: 'cur-sale-distributionStation-delivery-edit',
    //     name: 'cur-sale-distributionStation-delivery-edit',
    //     meta: {
    //         icon: 'md-people',
    //         title: '现售送货',
    //         notCache: true,
    //         hideInMenu: true,
    //         access: ['S', 'D'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/distributionStation-management/distributionStation-delivery/curSale-distributionStation-delivery-edit')
    // },


];

export default part;
